import { useTranslation } from "react-i18next";

import Navbar from "./navbar";
import downloadIcon from "../../images/icons/download.svg";
import threePhonesMock from "../../images/three-phones.png";
import threePhonesMockSm from "../../images/three-phones-sm.png";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <header id="home" className="w-full bg-main text-surface md:px-20">
      <div className="px-4">
        <Navbar />
      </div>

      <div className="container mx-auto w-full flex flex-col items-center gap-8 mt-8 px-4">
        <h1 className="text-4xl md:text-5xl font-bold text-center mt-8">
          {t("hero.title")}
        </h1>
        <p className="w-full md:w-[55%] text-wrap text-center text-lg font-normal px-4">
          {t("hero.description")}
        </p>

        <a
          href="#download-app"
          className="group bg-primary text-main flex items-center gap-3 text-xl font-medium px-7 py-3 rounded-[20px] overflow-hidden relative transition-colors duration-500 hover:bg-white"
        >
          <span className="relative block overflow-hidden">
            <span className="block transition-transform duration-500 group-hover:-translate-y-full">
              {t("hero.download_btn")}
            </span>
            <span className="absolute left-0 top-full block transition-transform duration-500 group-hover:-translate-y-full">
              {t("hero.download_btn")}
            </span>
          </span>

          <span className="relative block overflow-hidden w-6 h-6">
            <img
              src={downloadIcon}
              alt="Download App Now"
              className="block w-6 h-6 transition-transform duration-500 group-hover:-translate-y-full"
            />
            <img
              src={downloadIcon}
              alt="Download App Now"
              className="absolute left-0 top-full w-6 h-6 transition-transform duration-500 group-hover:-translate-y-full"
            />
          </span>
        </a>
      </div>
      <div className="w-full container mx-auto flex justify-center">
        <img
          src={threePhonesMockSm}
          alt="Specter App Mock Small"
          className="w-full block md:hidden"
        />

        <img
          src={threePhonesMock}
          alt="Specter App Mock"
          className="hidden md:block"
        />
      </div>
    </header>
  );
};

export default HeroSection;
